export class AuthError extends Error {
  userMessage: string;

  constructor(debugMessage: string, userMessage: string = 'An unexpected error occurred. Please try again later.') {
    super(debugMessage);
    this.userMessage = userMessage;
    this.name = 'AuthError';
  }
}
